module.exports = __webpack_public_path__ + "0d41426afe6047710f95042e011f292c.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room4/audio1/04_MCA-Administrating-Eternity.ogg
// module id = 783
// module chunks = 0